(() => {
  const source = document.querySelector('[data-hud-screen-product]');
  const data = source ? JSON.parse(source.textContent) : null;
  const publicLabel = value => value.replace(/\bPEMP\s+/ig, '').trim();
  const styleKey = value => value.match(/^(.*?\bPEMP\s+[A-Z0-9]+)/i)?.[1].trim() || value.trim();
  const finishLabel = value => {
    const options = value.split(' · ').slice(2).filter(part => /Blue Anti-glared|Hand drive|OEM Screen|OEM Display|NTG\d/i.test(part));
    return options.length ? options.join(' · ') : 'Standard';
  };
  let relatedProducts = null;
  function mountRelated() {
    if (!data?.isScreen || !relatedProducts || document.querySelector('.hud-screen-related')) return;
    const picker = document.querySelector('variant-picker');
    if (!picker) return;
    const section = document.createElement('section');
    section.className = 'hud-screen-related';
    const title = document.createElement('strong');
    title.textContent = 'Other CarPlay screens for your car';
    section.append(title);
    const grid = document.createElement('div');
    grid.className = 'hud-screen-related-grid';
    relatedProducts.forEach(item => {
      const link = document.createElement('a');
      link.href = item.url;
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        link.append(image);
      }
      const name = document.createElement('span');
      name.textContent = item.title.replace(/^(?:HUD|PEMP)\s+/, '');
      link.append(name);
      if (item.handle.startsWith('pemp-linux-')) {
        const badge = document.createElement('small');
        badge.textContent = 'Powered by PEMP';
        link.append(badge);
      }
      if (item.handle === data.handle) link.setAttribute('aria-current', 'page');
      grid.append(link);
    });
    section.append(grid);
    picker.after(section);
  }
  async function loadRelated() {
    if (!data?.isScreen || !data.related?.length) return;
    let vehicle;
    try { vehicle = JSON.parse(localStorage.getItem('hud.vehicle.v1')); } catch (_) {}
    if (!vehicle?.make || !vehicle?.model || !vehicle?.generation) return;
    try {
      const response = await fetch(data.fitmentUrl);
      if (!response.ok) return;
      const fitment = await response.json();
      const matches = fitment.rows.filter(row => row.make === vehicle.make && row.model === vehicle.model && row.code === vehicle.generation && (!vehicle.year || Number(vehicle.year) >= row.start && Number(vehicle.year) <= row.end));
      if (!matches.some(row => row.handle === data.handle)) return;
      const handles = new Set(matches.map(row => row.handle));
      relatedProducts = [...new Map(data.related.filter(item => handles.has(item.handle)).map(item => [item.handle, item])).values()];
      if (relatedProducts.length > 1) mountRelated();
    } catch (_) {}
  }
  function hideF34() {
    document.querySelectorAll('input[type="radio"]').forEach(input => {
      if (input.value.trim() === 'F34') input.closest('label')?.setAttribute('hidden', '');
    });
    document.querySelectorAll('.variant-option__button-label__text').forEach(label => {
      if (/\bF34\b/.test(label.textContent)) label.textContent = label.textContent.replace(/\s*\/\s*F34\b|\bF34\s*\/\s*/g, '');
    });
  }
  function cleanTitles() {
    document.querySelectorAll('h1, .quick-add-to-cart__title').forEach(el => {
      if (/^PEMP\b/.test(el.textContent.trim())) el.textContent = el.textContent.replace(/^PEMP\s+/, '');
    });
  }
  function mount() {
    hideF34();
    cleanTitles();
    mountRelated();
    if (!data) return;
    const fieldset = [...document.querySelectorAll('fieldset.variant-option')].find(el => el.querySelector('legend')?.textContent.trim() === 'Display');
    if (!fieldset || fieldset.querySelector('.hud-screen-style-swatches')) return;
    const inputs = [...fieldset.querySelectorAll('input[type="radio"]')];
    if (!inputs.length) return;
    const groups = new Map();
    inputs.forEach(input => {
      const key = styleKey(input.value);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(input);
    });
    const wrap = document.createElement('div');
    wrap.className = 'hud-screen-style-swatches';
    const heading = document.createElement('strong');
    heading.textContent = 'Choose your screen';
    wrap.append(heading);
    const tiles = document.createElement('div');
    tiles.className = 'hud-screen-style-grid';
    wrap.append(tiles);
    const finish = document.createElement('div');
    finish.className = 'hud-screen-finish';
    wrap.append(finish);
    for (const [key, choices] of groups) {
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'hud-screen-style-tile';
      const variant = data.variants.find(v => v.display === choices[0].value);
      if (variant?.image) {
        const img = document.createElement('img');
        img.src = variant.image;
        img.alt = '';
        img.loading = 'lazy';
        tile.append(img);
      }
      const name = document.createElement('span');
      name.textContent = publicLabel(key);
      tile.append(name);
      tile.setAttribute('aria-label', publicLabel(key));
      tile.addEventListener('click', () => {
        choices[0].click();
        update();
      });
      tile.dataset.style = key;
      tiles.append(tile);
    }
    if (data.poweredByPemp) {
      const badge = document.createElement('span');
      badge.className = 'hud-powered-badge';
      badge.textContent = 'Powered by PEMP';
      wrap.insertBefore(badge, tiles);
    }
    function update() {
      const selected = inputs.find(input => input.checked) || inputs[0];
      const key = styleKey(selected.value);
      tiles.querySelectorAll('button').forEach(tile => tile.setAttribute('aria-pressed', String(tile.dataset.style === key)));
      finish.replaceChildren();
      const choices = groups.get(key) || [];
      if (choices.length < 2) return;
      const caption = document.createElement('span');
      caption.textContent = 'Finish / fitment';
      finish.append(caption);
      choices.forEach(input => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = finishLabel(input.value);
        button.setAttribute('aria-pressed', String(input.checked));
        button.addEventListener('click', () => { input.click(); update(); });
        finish.append(button);
      });
    }
    fieldset.querySelectorAll('label.variant-option__button-label').forEach(label => label.hidden = true);
    fieldset.append(wrap);
    fieldset.addEventListener('change', update);
    update();
  }
  function start() {
    mount();
    loadRelated();
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; mount(); });
    }).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
